import { PathEnum } from '@/types/enums';
import { Pathnames } from 'next-intl/routing';

export const localePrefix = 'always';
export const defaultLocale = 'fr';
export const locales = [defaultLocale, 'en'] as const;

export const pathnames = {
    ...PathEnum,
} as Pathnames<typeof locales>;

export type AppPathnames = keyof typeof pathnames;
